<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{path:'/'}">首页</el-breadcrumb-item>
      <el-breadcrumb-item>学校列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="box-card">
    <el-row :gutter="20">
      <el-text>学校：</el-text>
      <el-col :span="4">
        <el-input
          placeholder="请输入内容"       
          clearable
          v-model="txt1">
          </el-input>  
      </el-col>
      <el-row>
        <el-button @click="searchPage" :icon="search" circle>
          <el-icon><Search /></el-icon>
        </el-button>
      </el-row>
    </el-row>
    <!-- 新增、批量删除按钮 -->
    <el-row class="bt">
      <el-button type="primary" @click="addClick">+新增</el-button>
    </el-row>
    <!-- 管理列表 -->
    <el-table :data="tableData" style="width:100%">
		  <el-table-column prop="name" label="学校" />
      <el-table-column label="校徽">
        <template #default="scope">
          <img :src="scope.row.icon" style="height: 50px; width:50px" v-if="scope.row.icon" />
        </template>
      </el-table-column>

      <el-table-column fixed="right" label="操作" width="150">
        <template #default="scope">
          <el-button link type="primary" size="small" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button link type="primary" size="small" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="kh-page">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100, 500]"
            :page-size="currentPageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount">
        </el-pagination>
    </div>
  </el-card>
</div>
</template>

  
<script>

  export default{
    data(){
      return {
        tableData : [],
        txt1: '',
        currentPage: 1,
        currentPageSize: 10,
        totalCount: 0
      }
    },
    mounted:function(){
      this.getPage()
    },
    methods:{
      //添加
      addClick(){
        this.$router.push("/Admin/SchoolsEdit")
      },
      getPage(){
        var ths = this
        var queryBO = {
          name: this.txt1,
          page: this.currentPage,
          pageSize: this.currentPageSize,
          sortField: ''
        }
        ths.$post('/Schools/queryPage',queryBO)
        .then(function (res) { 
            if(res.success){
              ths.tableData = res.data.rows
              ths.totalCount = res.data.records
            }
        })
        .catch(function (err) {
          console.log(err)
        })    
      },
      handleEdit(row){
        this.$router.push("/Admin/SchoolsEdit?id="+row.id)
      },
      handleDelete(row){
        if(confirm("确定要删除吗？")){
          var ths = this
          ths.$get('/Schools/delete?id='+row.id)
          .then(function (res) { 
              alert(res.msg)
              if(res.success){
                ths.getPage()
              }
          })
          .catch(function (err) {
            console.log(err)
          })    
        }
      },
      handleSizeChange(val) {
        this.currentPageSize = val
        this.getPage()
      },
      handleCurrentChange(val) {
        this.currentPage = val
        this.getPage()
      },
      searchPage(){
        this.currentPage = 1
        this.getPage()
      }
    }
  }

</script>

<style>
.bt{
  padding:20px 0;
}
</style>